import React from "react";
import {
  ArrowRight,
  Building2,
  Users,
  UsersRound,
  UserRound,
  Search,
  Clock,
  FileText,
  Target,
  BarChart3,
} from "lucide-react";

const iconMap = {
  Building2,
  Users,
  UsersRound,
  UserRound,
  Search,
  Clock,
  FileText,
  Target,
  BarChart3,
};

const Icon = ({ name, className }) => {
  const Cmp = iconMap[name] || Search;
  return <Cmp className={className} strokeWidth={2} />;
};

// theme = { key: 'blue' | 'green' }
const PathwayCard = ({ data, theme, onAction }) => {
  const isBlue = theme === "blue";

  const cardBg = isBlue
    ? "bg-gradient-to-br from-[#eef4fb] to-[#e6eef9]"
    : "bg-gradient-to-br from-[#eef7ef] to-[#e6f3ea]";

  const accent = isBlue ? "#1E4FA3" : "#16A34A";
  const iconTint = isBlue ? "text-[#1E4FA3]" : "text-[#16A34A]";

  const primaryBtn = isBlue
    ? "bg-[#1E4FA3] hover:bg-[#193f83]"
    : "bg-[#16A34A] hover:bg-[#138a3f]";

  const outlineBtn = isBlue
    ? "border-[#1E4FA3]/25 text-[#1E4FA3] hover:border-[#1E4FA3]/50"
    : "border-[#16A34A]/30 text-[#16A34A] hover:border-[#16A34A]/60";

  return (
    <div className={`relative flex h-full flex-col justify-center rounded-[22px] ${cardBg} p-5 sm:p-6 lg:p-7`}>
      {/* script accent (top-right of card) */}
      <div className="pointer-events-none absolute right-5 top-5 hidden text-right sm:block">
        <div className="font-script text-[22px] font-bold leading-[0.9] text-[#1E4FA3] lg:text-[24px]">
          {data.script.map((line, idx) => (
            <div key={idx}>{line}</div>
          ))}
        </div>
        <svg width="110" height="11" viewBox="0 0 110 11" className="ml-auto mt-0.5">
          <path
            d="M2 6 C 28 2, 82 2, 108 5"
            stroke={accent}
            strokeWidth="3"
            fill="none"
            strokeLinecap="round"
          />
        </svg>
      </div>

      <p className="text-[12px] font-semibold tracking-[0.18em] text-slate-500 sm:text-[13px]">
        {data.kicker}
      </p>

      <h2 className="mt-1.5 font-heading text-[28px] font-extrabold leading-[1.02] text-[#0B2545] sm:text-[34px] lg:text-[40px]">
        {data.title[0]}
        <br />
        {data.title[1]}
      </h2>

      <p className="mt-2.5 text-[17px] font-semibold text-[#0B2545] sm:text-[19px]">{data.lead}</p>
      <p className="mt-1.5 max-w-md text-[13px] leading-relaxed text-slate-600 sm:text-[14px]">
        {data.description}
      </p>

      {/* Actions */}
      <div className="mt-4 space-y-2.5">
        {data.actions.map((action) => {
          const isPrimary = action.variant === "primary";
          return (
            <button
              key={action.id}
              onClick={() => onAction(action.id)}
              className={`group flex w-full items-center gap-3 rounded-xl px-4 py-3 text-left transition-all duration-200 sm:gap-4 sm:px-5 ${
                isPrimary
                  ? `${primaryBtn} text-white shadow-md`
                  : `border-2 bg-white ${outlineBtn}`
              }`}
            >
              <Icon
                name={action.icon}
                className={`h-5 w-5 shrink-0 ${isPrimary ? "text-white" : iconTint}`}
              />
              <span className="flex-1 text-[15px] font-semibold sm:text-[16px]">{action.label}</span>
              <ArrowRight
                className="h-5 w-5 shrink-0 transition-transform duration-200 group-hover:translate-x-1"
                strokeWidth={2}
              />
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default PathwayCard;
